function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .color-primary {\n        fill: #28b485\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse",
  width: 209.1,
  height: 209.1,
  x: 1454.4,
  y: 326.4,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#333",
  floodOpacity: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "blur",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Ellipse)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 95.6,
  cy: 95.6,
  r: 95.6,
  fill: "#f5f8ff",
  transform: "translate(1463.4 332.4)"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 142.9,
  className: "color-primary",
  rx: 5,
  transform: "translate(1552.6 358.1)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 12.8,
  height: 142.9,
  className: "color-primary",
  rx: 5,
  transform: "rotate(90 603.6 1026.8)"
});

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1454.4 326.4 209.1 209.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.89e827e3.svg";
export { ForwardRef as ReactComponent };